<template>
  <div id="pie_echarts" class="pie" ref="pie"></div>
</template>

<script>
export default {
  name: "pie",

  methods: {
    fontSize(res, initWidth = 1920) {
      var nowClientWidth = document.documentElement.clientWidth;
      return res * (nowClientWidth / initWidth);
    },
    echartsLine() {
      var echarts = require("echarts");
      let energyConsumption = echarts.init(
        document.getElementById("pie_echarts")
      );
      energyConsumption.setOption({
        legend: {
          show: false,
        },
        title: [
          {
            show: true,
            text: "流量",
            left: "12%",
            top: "40%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
          {
            show: true,
            text: "水位",
            left: "45.5%",
            top: "40%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
          {
            show: true,
            text: "蒸发量",
            left: "77%",
            top: "40%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
          {
            show: true,
            text: "降雨量",
            left: "10%",
            top: "90%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
          {
            show: true,
            text: "流速",
            left: "45.5%",
            top: "90%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
          {
            show: true,
            text: "土壤墒情",
            left: "75%",
            top: "90%",
            textStyle: {
              fontSize: this.fontSize(12),
              color: "#a2c8f5",
            },
          },
        ],

        series: [
          {
            type: "pie",
            center: ["16.6%", "20%"],
            radius: ["28%", "35%"],
            clockwise: false,
            // color:['#4d5967','#0079ff'],
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#007aff") {
                  return `{num|${e.data.value}m³/s}`;
                }
              },
              rich: {
                num: {
                  color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 40 - 32.3 ,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 32.3,
                itemStyle: {
                  color: "#007aff",
                },
              },
            ],
          },
          {
            type: "pie",
            center: ["49.9%", "20%"],
            radius: ["28%", "35%"],
            clockwise: false,
            // color:['#4d5967','red'],
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#a5cfff") {
                  return `{num|${e.data.value}m}`;
                }
              },
              rich: {
                num: {
                   color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 200 - 191.65,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 191.65,
                itemStyle: {
                  color: "#a5cfff",
                },
              },
            ],
          },
          {
            type: "pie",
            name: "Apple",
            center: ["83.2%", "20%"],
            radius: ["28%", "35%"],
            clockwise: false,
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#00f9ff") {
                  return `{num|${e.data.value}mm}`;
                }
              },
              rich: {
                num: {
                   color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 5 - 3.3,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 3.3,
                itemStyle: {
                  color: "#00f9ff",
                },
              },
            ],
          },
          {
            type: "pie",
            name: "Apple",
            center: ["16.6%", "70%"],
            radius: ["28%", "35%"],
            clockwise: false,
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#00f9ff") {
                  return `{num|${e.data.value}mm}`;
                }
              },
              rich: {
                num: {
                   color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 2 - 1.5,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 1.5,
                itemStyle: {
                  color: "#00f9ff",
                },
              },
            ],
          },
          {
            type: "pie",
            name: "Apple",
            center: ["49.9%", "70%"],
            radius: ["28%", "35%"],
            clockwise: false,
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#0379ff") {
                  return `{num|${e.data.value}m³/s}`;
                }
              },
              rich: {
                num: {
                   color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 200 - 150,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 150,
                itemStyle: {
                  color: "#0379ff",
                },
              },
            ],
          },
          {
            type: "pie",
            name: "Apple",
            center: ["83.2%", "70%"],
            radius: ["28%", "35%"],
            clockwise: false,
            label: {
              show: true,
              position: "center",
              formatter: (e) => {
                if (e.color == "#ffc602") {
                  return `{num|${e.data.value}m²}`;
                }
              },
              rich: {
                num: {
                   color: "#fff",
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              scale: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 200 - 140,
                itemStyle: {
                  color: "#505a66",
                },
              },
              {
                value: 140,
                itemStyle: {
                  color: "#ffc602",
                },
              },
            ],
          },
        ],
      });
      window.addEventListener("resize", () => {
        energyConsumption.resize();
      });
    },
  },
  mounted() {
    this.echartsLine();
    window.addEventListener("resize", () => {
      this.echartsLine();
    });
  },
};
</script>

<style scoped="scoped">
#pie_echarts {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding:1vh 0;
}
</style>
